import React from 'react';
import { PropTypes } from 'prop-types';
import Icon from '../Icons/Icon';

const Cards = ({
  icon, title, body, href,
}) => {
  return (
    <>
      <div className="w-full md:w-2/4 lg:w-1/3 h-[330px] md:mb-2 lg:mb-6">
        <a
          className="inline-block w-[90%] h-[256px] px-5 py-3.5 rounded-10px shadow-vamos-shadow border-2 border-transparent cursor-pointer hover:border-vamos-black"
          href={href}
        >
          <Icon name={icon} className={`inline mr-2.5 ${icon === 'account_green' ? 'h-5 w-5' : 'h-6 w-6'}`} />
          <span className="text-8 font-bold">{title}</span>
          <p className="text-8 mt-[19.5px]">{body}</p>
        </a>
      </div>
    </>
  );
};

export default Cards;

Cards.propTypes = {
  icon: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
};
